import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { WeightUnity } from '../types/weight-unity.type';
import { CreateWeightUnityRequestDTO } from '../types/dtos/create-weight-unity.dto';
import { ADMIN_WEIGHT_UNITIES_API_PATHS } from '../constants/weight-unities-api-paths.constants';

type UseCreateWeightUnityResult = {
  createWeightUnity: (weightUnityData: CreateWeightUnityRequestDTO) => Promise<WeightUnity | null>;
  isSubmitting: boolean;
};

export function useCreateWeightUnity(): UseCreateWeightUnityResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createWeightUnity = async (weightUnityData: CreateWeightUnityRequestDTO): Promise<WeightUnity | null> => {
    setIsSubmitting(true);

    try {
      const createdWeightUnity = await HttpClient.post<WeightUnity, CreateWeightUnityRequestDTO>(
        ADMIN_WEIGHT_UNITIES_API_PATHS.CREATE_WEIGHT_UNITY,
        weightUnityData
      );

      enqueueSnackbar("L'unité de poids a été créée", { variant: 'success' });
      return createdWeightUnity;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de la création de l'unité de poids"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createWeightUnity, isSubmitting };
}
